import styled from 'styled-components';

export const CommentBox = styled.div`
  display: flex;
  gap: 1.25rem;
  max-width: 100%;
  overflow: hidden;

  color: #000;
  /* font */
  font-size: 0.875rem;
  line-height: 1.5rem;
`;

export const CommentInfo = styled.div`
  color: #959595;

  strong {
    color: ${props => props.theme.palette.text.primary};
  }

  * {
    vertical-align: bottom;
  }
`;

export const CommentDate = styled.time`
  font-size: 11px;
`;

export const Separator = styled.div`
  display: inline-block;
  margin-left: 4px;
  margin-right: 4px;
`;

export const CommentContent = styled.div<{ $highlighted?: boolean }>`
  background: ${props => (props.$highlighted ? props.theme.custom.colors.yellow : props.theme.custom.colors.gray100)};
  font-size: 13px;
  line-height: 20px;
  padding: 15px 20px;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 0.3125rem;
`;

export const CommentText = styled.div`
  margin-top: 5px;

  p {
    margin-bottom: 0;
    margin-top: 0;

    &:not(:first-child) {
      margin-top: 0.5rem;
    }
  }
`;

export const ReplyWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-left: 1rem;
`;

export const EmployeeBadgeWrapper = styled.div`
  display: inline;
  font-weight: bold;
  color: ${props => props.theme.palette.primary.main};

  svg {
    display: inline-block;
    font-size: 1rem;
    margin-bottom: 2px;
    margin-right: 0.5rem;
  }
`;

export const UserName = styled.span``;

export const ReplyLink = styled.a`
  color: ${props => props.theme.custom.colors.black};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.custom.colors.brand};
  }
`;

export const ReplyFormWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  margin-left: 2rem;
`;

export const Action = styled.div`
  display: flex;
  gap: 1rem;
`;
